import { BreakPoints, Flex, Spacer, useBreakpoint } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { useResolve } from '@visiba/instantiation';
import { SignInController } from './sign_in.controller';
import styled from 'styled-components';
import { IllustrativeDefault } from '../../../../patient/src/views/view_guest/_illustrative.component';
import { Auth } from '@feature/auth/mod';
import { Logo } from '@component/logo.component';

interface Props {
	__TEMP__onCloseSignIn: () => void;
}

export function SignIn(props: Props): JSX.Element {
	const smallBreakpoint = useBreakpoint(BreakPoints.Small);
	const controller = useResolve(SignInController);
	const returnUrl = controller.selectMethod();

	return (
		<OutletIdp {...props}>
			{smallBreakpoint ? <Spacer vertical={tokens.size.x7} /> : null}

			<Flex
				grow='1'
				gap={tokens.spacing.x4}
				style={{
					margin: `0 ${tokens.spacing.x2}`,
					height: '100%',
				}}
				data-testid='sign_in'
			>
				<Auth.Methods returnUrl={returnUrl} />
			</Flex>
		</OutletIdp>
	);
}

const StyledContainer = styled.div`
	width: 100%;
	height: 100%;
	margin: ${tokens.spacing.x2} 0 ${tokens.spacing.x1};

	${tokens.breakpointQuery.large} {
		padding-top: 240px;
		max-width: 500px;
		max-height: 700px;
	}
`;

const StyledHeader = styled.div`
	display: none;

	${tokens.breakpointQuery.large} {
		display: block;
		position: fixed;
		top: ${tokens.spacing.x3};
		left: ${tokens.spacing.x3};
		z-index: 1;
	}
`;

const SideAreaContent = styled.div`
	width: 630px;
`;

const SideArea = styled.div`
	position: fixed;
	right: 0;
	top: 0;
	display: flex;
	width: 630px;
	min-height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	padding: 0px 65px;
	background-color: ${tokens.color.bg.surfaceBrand};
	pointer-events: none;
`;

function OutletIdp(props: React.PropsWithChildren<Props>): JSX.Element {
	const largeBreakpoint = useBreakpoint(BreakPoints.Large);

	return (
		<Flex
			grow={1}
			direction='row'
			style={{
				height: '100%',
				minHeight: '100%',
			}}
		>
			<Flex
				grow={1}
				breakpointLargeAndUp={{
					align: 'center',
				}}
			>
				<StyledContainer>
					<StyledHeader>
						<Logo
							onClick={(e) => {
								// We need to manually close the modal containing the sign-in stuff.
								// This is a temporary solution to close the modal.
								e.preventDefault();
								props.__TEMP__onCloseSignIn();
							}}
						/>
					</StyledHeader>

					{props.children}
				</StyledContainer>
			</Flex>

			{largeBreakpoint ? (
				<SideAreaContent>
					<SideArea>
						<IllustrativeDefault />
					</SideArea>
				</SideAreaContent>
			) : null}
		</Flex>
	);
}
